export default class {
  constructor() {
    $(function() {
      $('#btn-search').on('click', subSearch_open);
      $(document).on('click', function(event) {
        if (!$(event.target).closest('.header').length) {
          subSearch_close();
        }
      });

      function subSearch_open() {
        $(this).closest('.header').addClass('-active');
      }

      function subSearch_close() {
        $('.header').removeClass('-active');
      }
    });
  }
}
